import { useCallback, useState } from 'react';

const STORAGE_KEY = 'hiddenPageHeaders';

type PageId = 'dashboard' | 'worklog' | 'reports';

const getHiddenHeaders = (): Set<PageId> => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return new Set(JSON.parse(stored) as PageId[]);
    }
  } catch {
    // Ignore parse errors
  }
  return new Set();
};

const saveHiddenHeaders = (hidden: Set<PageId>) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(hidden)));
};

export const usePageHeaderVisibility = (pageId: PageId) => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(() => {
    const hidden = getHiddenHeaders();
    return !hidden.has(pageId);
  });

  const hideHeader = useCallback(() => {
    const hidden = getHiddenHeaders();
    hidden.add(pageId);
    saveHiddenHeaders(hidden);
    setIsHeaderVisible(false);
  }, [pageId]);

  const showHeader = useCallback(() => {
    const hidden = getHiddenHeaders();
    hidden.delete(pageId);
    saveHiddenHeaders(hidden);
    setIsHeaderVisible(true);
  }, [pageId]);

  return {
    isHeaderVisible,
    hideHeader,
    showHeader,
  };
};
